<app-loader *ngIf="loaderIcon | async"></app-loader>

<span class="head_msg phonetogg" *ngIf="!isAdmin && !isCallCenterAgent" (click)="openPopup(); phonePopup.emit()">
    <span class="phone-icon"></span>

    <span class="notification-badge" *ngIf="counts.all > 0">
        {{ counts.all }}
    </span>
</span>
<!-- PHONE POPUP -->
<div class="call-popup" *ngIf="isPopupOpen">
    <div class="call-header">
        <h3>Call Notifications</h3>
        <button type="button" class="close text-white" (click)="cancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="call-tabs">
        <button class="tab" [class.active]="activeTab === 'all'" (click)="setActiveTab('all')">
            All <small *ngIf="counts.all > 0">{{ counts.all }}</small>
        </button>
        <button class="tab" [class.active]="activeTab === callTypeEnum.Missed"
            (click)= "setActiveTab(callTypeEnum.Missed)">
            Missed <small *ngIf="counts.missed > 0">{{counts.missed}}</small>
        </button>
        <button class="tab" [class.active]="activeTab === callTypeEnum.Inbound"
            (click)= "setActiveTab(callTypeEnum.Inbound)">
            Inbound <small *ngIf="counts.inbound > 0">{{counts.inbound}}</small>
        </button>
        <button class="tab" [class.active]="activeTab === callTypeEnum.Voicemail"
            (click)="setActiveTab(callTypeEnum.Voicemail)">
            VoiceMail <small *ngIf="counts.voicemail > 0">{{counts.voicemail}}</small>
        </button>
    </div>
    <div #callBody class="call-body">
        <div class="call-card" *ngFor="let call of filteredNotifications" [ngClass]="getCallTypeClass(call.CallType)">
            <button type="button" class="card-close" (click)="initiateDelNotif.emit(call.PhoneId)" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="call-left">
                <div class="icon"></div>
            </div>

            <div class="call-content">
                <b class="tenant-line">
                    {{call.TenantName || 'Unknown Caller'}} - {{formatPhoneNumber(call.PhoneNumber)}}
                </b>

                <small class="duration">
                    {{ getTimeDisplay(call.Time) }}
                </small>

                <div class="call-bottom">
                    <span class="unit-pill" *ngIf="call.UnitNumber">
                        <span class="unit-icon"></span>
                        Unit # {{call.UnitNumber}}
                    </span>

                    <div class="call-actions" (click)="openRelinkPopup(call)">
                        <button> {{ (call.TenantName || call.UnitNumber) ? 'Relink' : 'Link' }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>